<utc-create-account-header
    [hideCancelButton]="true"
>
</utc-create-account-header>

<div class='hvac-delete-account-information'>
    <h2 class='hvac-delete-account-information-title hvac-hero-large-text'> {{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.DELETE_ACCOUNT_PAGE.TITLE' | translate }}</h2>
    <div class="hvac-delete-account-url-link">
        <p class='hvac-delete-account-information-body'>{{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.DELETE_ACCOUNT_PAGE.DESCRIPTION' | translate }}</p>
        <a class="hvac-delete-account-information-body" href="https://hvacpartners.com/profile/delete-account">{{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.DELETE_ACCOUNT_PAGE.URL_LINK' | translate}}</a>
    </div>
    <p class='hvac-delete-account-information-body'>{{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.DELETE_ACCOUNT_PAGE.PROFILE_INSTRUCTION' | translate }}</p>
    <p class='hvac-delete-account-information-body'>{{'ACCOUNT_ADMIN.DELETE_MY_ACCOUNT.DELETE_ACCOUNT_PAGE.CONFIRMATION_EMAIL_MESSAGE' | translate }}</p>

</div>


<!--
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>HVACpartners – Delete My Account</title>
  <style>
    :root {
      --brand-blue: #1891F6;
      --text: #0f172a;
      --muted: #334155;
      --bg: #0b1220;
      --card: #111827;
      --card-border: #1f2937;
      --white: #ffffff;
    }

    html, body {
      margin: 0;
      padding: 0;
      font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
      color: #637082;
      background: whitesmoke;
      min-height: 100vh;
    }

    .page {
      max-width: 880px;
      margin: 0 auto;
      padding: 32px 20px 64px;
    }

    /* Header */
    .header {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 16px 0 28px;
    }
    .logo {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      padding: 10px 12px;
    }
    .brand-name {
      position: absolute;
      left: -10000px;
      top: auto;
      width: 1px;
      height: 1px;
      overflow: hidden;
    }

    /* Card */
    .card {
      background: whitesmoke;
      border-radius: 16px;
      padding: 24px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.45);
      backdrop-filter: blur(6px);
    }

    h1 {
      font-size: 28px;
      line-height: 1.2;
      margin: 0 0 16px;
    }
    p {
      color: #637082;
      margin: 0 0 14px;
      font-size: 16px;
      line-height: 1.6;
    }

    .link-block {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin: 14px 0 8px;
    }
    a {
      color: var(--brand-blue);
      text-decoration: none;
      word-break: break-all;
    }
    a:hover { text-decoration: underline; }

    .note {
      margin-top: 8px;
      color: #637082;
    }

    @media (min-width: 640px) {
      h1 { font-size: 32px; }
      .card { padding: 28px; }
    }
  </style>
</head>
<body>
  <div class="page">
    <header class="header" aria-label="HVACpartners">
      <div class="logo" title="HVACpartners">
        // Inline SVG logo from the provided markup
        <svg viewBox="0 0 140 16" width="140" height="16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <g fill="none" fill-rule="evenodd">
            <g fill-rule="nonzero">
              <g>
                <path class="logo-type" d="M30.958,2.76 L33.366,2.76 L33.366,12 L30.958,12 L30.958,8.276 L27.43,8.276 L27.43,12 L25.022,12 L25.022,2.76 L27.43,2.76 L27.43,6.414 L30.958,6.414 L30.958,2.76 Z M43.866,2.76 L40.59,12 L37.762,12 L34.472,2.76 L37.006,2.76 L38.7,8.346 L39.204,10.166 L39.694,8.374 L41.416,2.76 L43.866,2.76 Z M50.894,12 L50.264,9.914 L47.072,9.914 L46.428,12 L44.006,12 L47.254,2.76 L50.138,2.76 L53.372,12 L50.894,12 Z M47.576,8.276 L49.76,8.276 L49.088,6.064 L48.682,4.608 L48.654,4.608 L48.276,6.05 L47.576,8.276 Z M62.64,9.354 C62.094,11.286 60.554,12.14 58.594,12.14 C55.78,12.14 54.058,10.362 54.058,7.38 C54.058,4.398 55.794,2.62 58.58,2.62 C60.512,2.62 62.066,3.418 62.528,5.168 L60.414,6.022 C60.148,4.874 59.616,4.51 58.664,4.51 C57.32,4.51 56.522,5.49 56.522,7.38 C56.522,9.256 57.264,10.25 58.622,10.25 C59.658,10.25 60.232,9.774 60.456,8.738 L62.64,9.354 Z M71.894,2.76 C73.882,2.76 75.142,3.838 75.142,5.644 C75.142,7.436 73.882,8.514 71.894,8.514 L69.836,8.514 L69.836,12 L68.338,12 L68.338,2.76 L71.894,2.76 Z M71.656,7.24 C72.986,7.24 73.588,6.694 73.588,5.644 C73.588,4.594 72.986,4.034 71.656,4.034 L69.836,4.034 L69.836,7.24 L71.656,7.24 Z M83.206,12 L82.338,9.578 L78.446,9.578 L77.564,12 L76.024,12 L79.51,2.76 L81.302,2.76 L84.788,12 L83.206,12 Z M78.88,8.36 L81.89,8.36 L80.826,5.392 L80.406,4.062 L80.364,4.062 L79.972,5.364 L78.88,8.36 Z M92.25,12 L89.898,8.304 L87.91,8.304 L87.91,12 L86.426,12 L86.426,2.76 L90.192,2.76 C92.18,2.76 93.426,3.796 93.426,5.532 C93.426,6.862 92.698,7.772 91.466,8.136 L93.972,12 L92.25,12 Z M87.91,4.034 L87.91,7.058 L90.066,7.058 C91.284,7.058 91.872,6.568 91.872,5.546 C91.872,4.524 91.284,4.034 90.066,4.034 L87.91,4.034 Z M102.708,2.76 L102.708,4.048 L99.544,4.048 L99.544,12 L98.046,12 L98.046,4.048 L94.882,4.048 L94.882,2.76 L102.708,2.76 Z M112.074,2.76 L112.074,12 L110.296,12 L106.726,6.176 L105.83,4.468 L105.816,4.468 L105.872,6.036 L105.872,12 L104.5,12 L104.5,2.76 L106.264,2.76 L109.82,8.57 L110.73,10.292 L110.744,10.292 L110.688,8.724 L110.688,2.76 L112.074,2.76 Z M116.302,10.712 L121.692,10.712 L121.692,12 L114.804,12 L114.804,2.76 L121.496,2.76 L121.496,4.048 L116.302,4.048 L116.302,6.708 L120.362,6.708 L120.362,7.968 L116.302,7.968 L116.302,10.712 Z M129.532,12 L127.18,8.304 L125.192,8.304 L125.192,12 L123.708,12 L123.708,2.76 L127.474,2.76 C129.462,2.76 130.708,3.796 130.708,5.532 C130.708,6.862 129.98,7.772 128.748,8.136 L131.254,12 L129.532,12 Z M125.192,4.034 L125.192,7.058 L127.348,7.058 C128.566,7.058 129.154,6.568 129.154,5.546 C129.154,4.524 128.566,4.034 127.348,4.034 L125.192,4.034 Z M136.266,2.62 C137.974,2.62 139.15,3.236 139.962,4.496 L138.828,5.518 C138.31,4.412 137.596,3.922 136.28,3.922 C134.964,3.922 134.25,4.51 134.25,5.294 C134.25,6.036 134.824,6.428 136.616,6.75 C139.094,7.184 140.004,7.954 140.004,9.438 C140.004,11.09 138.506,12.14 136.322,12.14 C134.306,12.14 133.06,11.412 132.346,10.264 L133.396,9.214 C133.998,10.334 134.922,10.838 136.308,10.838 C137.624,10.838 138.436,10.376 138.436,9.522 C138.436,8.864 137.876,8.486 136.14,8.164 C133.606,7.688 132.668,6.918 132.668,5.448 C132.668,3.88 134.012,2.62 136.266,2.62 Z" fill="#000000"></path>
                <path class="mark" d="M7.3369488,9.18728796 C7.73497271,8.79090814 8.36297187,8.85785217 8.69377632,9.3185536 C9.81798214,11.0649626 9.55307394,13.3054132 8.09806367,14.7544616 C6.64318572,16.2048277 4.32742227,16.3695522 2.63979031,15.3477333 C2.14357041,14.9848123 2.1112839,14.3915406 2.50798459,13.9964654 C3.73283436,12.7776228 6.27992936,10.2399762 7.3369488,9.18728796 Z M14.7493369,7.90151453 C16.2056704,9.35043108 16.3710727,11.6567056 15.3450496,13.3374225 C14.9806354,13.8316091 14.3849228,13.8637633 13.9882221,13.4686881 C12.7633723,12.2498456 10.2821736,9.77911008 9.15925787,8.65951071 C8.72896068,8.23096349 8.82846665,7.63769179 9.29106359,7.30824282 C11.044658,6.18864345 13.2607169,6.41899417 14.7493369,7.90151453 Z M2.01177792,2.46575152 C3.23662769,3.6845941 5.71782644,6.18876864 6.84074213,7.27492895 C7.23875281,7.67132194 7.17153335,8.29674786 6.70893641,8.62619683 C4.95534204,9.7457962 2.70567333,9.48197347 1.25066305,8.03292513 C-0.20567044,6.58400857 -0.371072663,4.27773402 0.654950406,2.59701717 C1.01936458,2.10283054 1.61507723,2.07067632 2.01177792,2.46575152 Z M13.4260398,0.652266733 C13.9222597,1.01518772 13.9545462,1.60845942 13.5578455,2.00353462 C12.3665724,3.22369499 9.78593381,5.7923427 8.69530463,6.84631584 C8.29728072,7.24269566 7.66928156,7.17575163 7.33847712,6.71505019 C6.2465578,4.96864122 6.511466,2.69587162 7.96776641,1.24553843 C9.42264437,-0.204827701 11.7384078,-0.369552185 13.4260398,0.652266733 Z" fill="#009DA3"></path>
              </g>
            </g>
          </g>
        </svg>
        <span class="brand-name">HVACpartners</span>
      </div>
    </header>

    <main class="card" role="main">
      <h1>Delete My Account</h1>

      <p>To request an account deletion, please log in to HVACpartners and navigate to the following URL to request deletion:</p>

      <div class="link-block">
        <a href="https://hvacpartners.com/profile/delete-account">https://hvacpartners.com/profile/delete-account</a>
      </div>


	<p>
        If you have an account in any of the applications listed below,
        deleting your user profile on <strong>HVACpartners</strong> will also
        remove your profile from these applications:
    </p>

    <ul>
        <li>Carrier Service Technician</li>
        <li>Bryant Service Technician</li>
        <li>RC Mobile Technician</li>
        <li>Fast OEM Mobile Tech</li>
    </ul>


      <p>You can also find this link under your Profile in HVACpartners.</p>

      <p class="note">Once you have submitted the form, you will receive a confirmation email at the address associated with your HVACpartners account. Processing to delete your HVACpartners account may take up to 10 business days.</p>

	  <p>Some information may still be retained if required for legal or regulatory compliance.</p>
    </main>
  </div>
</body>
</html> -->
